module.exports = __webpack_public_path__ + "img/list-vps.f735948 1.6acf947.svg";